import { RESERVED_CATEGORY_SLUGS, isExclusiveOffersQuery, getExclusiveOffersLocation, withLocale, catalogPath, NOT_FOUND_PATH } from '@/util/categoryRoute'

// 商品相关
const productRoutes = [
  {
    path: withLocale('/product'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/product'),
        name: 'productMain',
        component: () => import('@/views/product/details/index.vue'),
        meta: {
          cnName: '产品详情',
          enName: 'Product Detail'
        }
      },
      {
        path: catalogPath('/products/:slug'),
        name: 'productDetail',
        component: () => import('@/views/product/details/index.vue'),
        meta: {
          cnName: '产品详情',
          enName: 'Product Detail'
        }
      },
      {
        path: withLocale('/productList'),
        name: 'productList',
        component: () => import('@/views/product/list/index.vue'),
        meta: {
          cnName: '产品列表',
          enName: 'Product List'
        },
        beforeEnter: (to) => {
          if (isExclusiveOffersQuery(to.query)) return getExclusiveOffersLocation(to.query)
          return true
        }
      },
      {
        path: catalogPath('/exclusive-offers'),
        name: 'exclusiveOffers',
        component: () => import('@/views/product/list/index.vue'),
        meta: {
          cnName: '独家优惠',
          enName: 'Exclusive Offers'
        }
      },
      {
        path: catalogPath('/:l1/:l2?/:l3?'),
        name: 'categoryList',
        component: () => import('@/views/product/list/index.vue'),
        meta: {
          cnName: '产品列表',
          enName: 'Product List'
        },
        beforeEnter: (to) => {
          const l1 = String(to.params.l1 || '').toLowerCase()
          if (RESERVED_CATEGORY_SLUGS.has(l1)) return { path: NOT_FOUND_PATH }
          return true
        }
      },
      {
        path: withLocale('/cart'),
        name: 'CART',
        component: () => import('@/views/cart/index.vue'),
        meta: {
          cnName: '购物车',
          enName: 'Cart'
        }
      }
    ]
  }
]

export default productRoutes
